import React from 'react';
import {Card, Col, Placeholder, Row} from 'react-bootstrap';

const PLATFORM_ICONS = 5;
const COUNTRY_ICONS = 3;
const METRIC_LINES = [6, 7, 10];

export function InviteCardSkeleton() {
    return (
        <Card className="booking-card h-100 mb-3 position-relative border-top-0 border-right-0" aria-hidden="true">
            <div className="d-flex flex-column flex-md-row p-3 justify-content-between align-items-center">
                <Placeholder as="div" animation="glow" className="d-flex align-items-center w-md-50">
                    <Placeholder className="skeleton skeleton-circle" />
                    <Placeholder xs={6} className="skeleton ms-2" />
                </Placeholder>
                <Placeholder as="div" animation="glow" className="d-flex gap-2 w-100 justify-content-md-end">
                    {Array.from({ length: PLATFORM_ICONS }).map((_, i) => (
                        <Placeholder key={i} className="skeleton skeleton-icon" />
                    ))}
                </Placeholder>
            </div>
            <Row className="h-100 px-3 pb-3 m-0 w-100">
                <Col className="p-md-0" md={3}>
                    <Placeholder as="div" animation="glow">
                        <Placeholder className="skeleton skeleton-image" />
                    </Placeholder>
                </Col>
                <Col md={9} className="d-flex flex-column justify-content-between pr-0">
                    <Row>
                        <Col md={6}>
                            <Placeholder as="div" animation="glow">
                                {METRIC_LINES.map((width, i) => (
                                    <Placeholder key={i} xs={width} className="skeleton d-block my-2" />
                                ))}
                            </Placeholder>
                        </Col>
                        <Col md={6} className="p-0">
                            <Placeholder as="div" animation="glow">
                                <Placeholder xs={6} className="skeleton d-block mb-2" />
                                <div className="d-flex gap-2">
                                    {Array.from({ length: COUNTRY_ICONS }).map((_, i) => (
                                        <Placeholder key={i} className="skeleton skeleton-icon" />
                                    ))}
                                </div>
                            </Placeholder>
                        </Col>
                    </Row>
                    <Placeholder
                        as="div"
                        animation="glow"
                        className="d-flex w-100 justify-content-end mb-3 mb-md-0 mt-3"
                    >
                        <Placeholder className="skeleton skeleton-action-btn" />
                    </Placeholder>
                </Col>
            </Row>
        </Card>
    );
}
